module.exports = __webpack_public_path__ + "img/cand-approval-approve.e2bc7f86.svg";